import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-af3e414c")

_pushScopeId("data-v-af3e414c")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Dettaglio ticket")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Dettaglio ticket")
const _hoisted_3 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" ID ")
const _hoisted_6 = { class: "base_text" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Cliente ")
const _hoisted_8 = {
  class: "base_text",
  style: {"color":"#3880ff"}
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Data assegnazione ")
const _hoisted_10 = { class: "base_text" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Impianto ")
const _hoisted_13 = {
  class: "base_text",
  style: {"color":"#3880ff"}
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Categoria")
const _hoisted_15 = { class: "base_text" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Stato")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("N° tecnici previsti")
const _hoisted_18 = { class: "base_text" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Tecnici")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Titolo")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Descrizione")
const _hoisted_23 = { class: "btn_action" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Crea intervento ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Crea Intervento ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_back_button = _resolveComponent("ion-back-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_text = _resolveComponent("ion-text")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_router_link = _resolveComponent("router-link")
  const _component_ion_badge = _resolveComponent("ion-badge")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_back_button)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_header, { collapse: "condense" }, {
            default: _withId(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_back_button)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withId(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "primary"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode(_component_ion_list, { class: "ion-padding-horizontal" }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_label, { color: "primary" }, {
                          default: _withId(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_text, null, {
                          default: _withId(() => [
                            _createVNode("p", _hoisted_6, "TK" + _toDisplayString($setup.ticket.tickets_id), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      to: {
              name: 'ClienteDetail',
              params: { id: $setup.ticket.tickets_customer_id },
            },
                      style: {"text-decoration":"none","color":"inherit"}
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_item, {
                          class: "ion-no-padding",
                          button: "true",
                          detail: ""
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_label, { color: "primary" }, {
                              default: _withId(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_text, null, {
                              default: _withId(() => [
                                _createVNode("p", _hoisted_8, _toDisplayString($setup.riferimentoCliente($setup.ticket)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_label, { color: "primary" }, {
                          default: _withId(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_text, null, {
                          default: _withId(() => [
                            _createVNode("p", _hoisted_10, _toDisplayString($setup.dateFormat($setup.ticket.tickets_assign_date) || "-"), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    ($setup.ticket.tickets_project_id != null)
                      ? (_openBlock(), _createBlock("div", _hoisted_11, [
                          _createVNode(_component_router_link, {
                            to: {
                name: 'CommessaDetail',
                params: {
                  id: $setup.ticket.tickets_customer_id,
                  id_commessa: $setup.ticket.tickets_project_id,
                },
              },
                            style: {"text-decoration":"none","color":"inherit"}
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_item, {
                                class: "ion-no-padding",
                                button: "true",
                                detail: ""
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_label, { color: "primary" }, {
                                    default: _withId(() => [
                                      _hoisted_12
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_text, null, {
                                    default: _withId(() => [
                                      _createVNode("p", _hoisted_13, _toDisplayString($setup.ticket.projects_codice || "-"), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_label, { color: "primary" }, {
                          default: _withId(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_text, null, {
                          default: _withId(() => [
                            _createVNode("p", _hoisted_15, _toDisplayString($setup.checkField($setup.ticket.tickets_category_value)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_label, { color: "primary" }, {
                          default: _withId(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_text, null, {
                          default: _withId(() => [
                            _createVNode(_component_ion_badge, {
                              color: $setup.statoTicket($setup.ticket.tickets_status_id)
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString($setup.ticket.tickets_status_value), 1)
                              ]),
                              _: 1
                            }, 8, ["color"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_label, { color: "primary" }, {
                          default: _withId(() => [
                            _hoisted_17
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_text, null, {
                          default: _withId(() => [
                            _createVNode("p", _hoisted_18, _toDisplayString($setup.checkField($setup.ticket.tickets_num_tecnici)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_label, { color: "primary" }, {
                          default: _withId(() => [
                            _hoisted_19
                          ]),
                          _: 1
                        }),
                        ($setup.ticket.tickets_tecnici)
                          ? (_openBlock(), _createBlock(_component_ion_text, { key: 0 }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.ticket.tickets_tecnici, (tecnico, index) => {
                                  return (_openBlock(), _createBlock("div", {
                                    style: {"padding":"3px 0","text-align":"right"},
                                    key: index
                                  }, _toDisplayString(tecnico), 1))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_ion_text, { key: 1 }, {
                              default: _withId(() => [
                                _hoisted_20
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_row, null, {
                          default: _withId(() => [
                            _createVNode(_component_ion_col, {
                              size: "8",
                              class: "fontSize",
                              style: {"padding-top":"10px","padding-left":"0"}
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_ion_label, { color: "primary" }, {
                                  default: _withId(() => [
                                    _hoisted_21
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_col, {
                              size: "12",
                              style: {"font-size":"14px","padding-left":"0","padding-right":"0"}
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString($setup.checkField($setup.ticket.tickets_subject)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_row, null, {
                          default: _withId(() => [
                            _createVNode(_component_ion_col, {
                              size: "8",
                              class: "fontSize",
                              style: {"padding-top":"10px","padding-left":"0"}
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_ion_label, { color: "primary" }, {
                                  default: _withId(() => [
                                    _hoisted_22
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_col, {
                              size: "12",
                              style: {"font-size":"14px","padding-left":"0","padding-right":"0"}
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString($setup.parseHtmlEnteties($setup.checkField($setup.ticket.tickets_message))), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode("div", _hoisted_23, [
                  _withDirectives(_createVNode(_component_ion_button, {
                    color: "success",
                    size: "default",
                    expand: "block",
                    onClick: $setup.openModal
                  }, {
                    default: _withId(() => [
                      _hoisted_24
                    ]),
                    _: 1
                  }, 8, ["onClick"]), [
                    [_vShow, !$setup.created]
                  ]),
                  _withDirectives(_createVNode(_component_ion_button, {
                    color: "success",
                    size: "default",
                    expand: "block",
                    disabled: ""
                  }, {
                    default: _withId(() => [
                      _hoisted_25
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, $setup.created]
                  ])
                ])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})